import React from 'react';

import { Home, User, Gift, Trophy, Settings, Menu, LogOut } from 'lucide-react';
import aladipattiyan from "../assets/aaladippattiyan_logo.png"


export const Navigation = ({

  activeTab,

  onTabChange,

  isMobileMenuOpen,

  onMobileMenuToggle,

  onLogout

}) => {

  const navItems = [

    { id: 'dashboard', label: 'Dashboard', icon: Home },

    { id: 'profile', label: 'Profile', icon: User },

    { id: 'rewards', label: 'Rewards', icon: Gift },

    // { id: 'loyalty', label: 'Loyalty Tiers', icon: Trophy },

    // { id: 'settings', label: 'Settings', icon: Settings }

  ];



  return (

    <>

      {/* Desktop Navigation */}

      <nav className="hidden lg:flex bg-white shadow-lg border-b border-gray-200">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">

          <div className="flex justify-between items-center h-16">

            {/* Left: Logo */}

            <div className="flex items-center gap-3">

              <div className="w-10 h-10 bg-gradient-to-br  rounded-full flex items-center justify-center">

                <img src={aladipattiyan} alt="logo"/>

              </div>

              <h1 className="text-xl font-bold text-gray-800">Aaladipattiyan</h1>

            </div>



            {/* Centered Nav Items */}

            <div className="flex absolute left-1/2 transform -translate-x-1/2 space-x-4">

              {navItems.map((item) => (

                <button

                  key={item.id}

                  onClick={() => onTabChange(item.id)}

                  className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === item.id

                    ? 'text-orange-600 bg-orange-50'

                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'

                    }`}

                >

                  <item.icon size={18} />

                  {item.label}

                </button>

              ))}

            </div>



            {/* Right: Sign Out */}

            <div className="flex items-center">

              {onLogout && (

                <button

                  onClick={onLogout}

                  className="flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-2 rounded-full font-semibold transition-colors"

                >

                  <LogOut size={16} />

                  Sign Out

                </button>

              )}

            </div>

          </div>

        </div>

      </nav>



      {/* Mobile Navigation */}

      <nav className="lg:hidden bg-white shadow-lg border-b border-gray-200">

        <div className="px-4 sm:px-6">

          <div className="flex justify-between items-center h-16">

            <div className="flex items-center gap-3">

              <div className="w-8 h-8 bg-gradient-to-br  rounded-full flex items-center justify-center">

               <img src={aladipattiyan} alt="logo"/>

              </div>

              <h1 className="text-lg font-bold text-gray-800">Aaladipattiyan</h1>

            </div>



            <button

              onClick={onMobileMenuToggle}

              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-50"

            >

              <Menu size={24} />

            </button>

          </div>

        </div>





        {/* Mobile Menu */}

        {isMobileMenuOpen && (

          <div className="border-t border-gray-200 bg-white">

            <div className="px-2 pt-2 pb-3 space-y-1">

              {navItems.map((item) => (

                <button

                  key={item.id}

                  onClick={() => {

                    onTabChange(item.id);

                    onMobileMenuToggle();

                  }}

                  className={`flex items-center gap-3 w-full px-3 py-2 rounded-md text-base font-medium transition-colors ${activeTab === item.id

                    ? 'text-orange-600 bg-orange-50'

                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'

                    }`}

                >

                  <item.icon size={20} />

                  {item.label}

                </button>

              ))}



              {/* Mobile Sign Out */}

              {onLogout && (

                <button

                  onClick={() => {

                    onLogout();

                    onMobileMenuToggle();

                  }}

                  className="flex items-center gap-2 w-full px-3 py-2 mt-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-md font-semibold transition-colors"

                >

                  <LogOut size={16} />

                  Sign Out

                </button>

              )}

            </div>

          </div>

        )}

      </nav>

    </>

  );

};
